<template>
  <a-modal :title="title" :visible="visible" @ok="ok" @cancel="cancel" okText='确定' cancelText='取消' destroyOnClose
    :maskClosable="false" width="800px">
    <div class="raw-model-info-row">已选中配方：
      <span>{{ formulaSelectedRows.map(item => `【${item.formulaName}】`).join(',') }}</span>
    </div>
    <div class="raw-model-info-row">可删除原料明细：</div>
    <a-row type="flex" justify="space-between" align="middle" style="margin-bottom:10px">
      <div>
        <a-input @change='filterList' v-model="searchKey" placeholder="原料名称/代码">
          <a-icon slot="suffix" type="search" @click="filterList" />
        </a-input>
      </div>
      <div>
        <type-list v-model="typeId" category="raw" @setVal='setVal' placeholder="选择原料类型" />
      </div>
    </a-row>
    <a-table ref="listRef" :columns="columns" :data-source="list" :pagination="false" :scroll="{ y }"
      :row-selection="rowSelection" row-key="id">
      <template slot="rawTypeName" slot-scope="text, record, index">
        <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record, index)">
          <template slot="title">
            {{ record.fullTypeName }}
          </template>
          <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
        </a-tooltip>
      </template>
      <div slot="status" slot-scope="text, record">
        <span :style="{ color: !text ? 'green' : 'red' }">{{
          !text ? "激活" : "失效"
          }}</span>/{{ record.categoryTypeName ? record.categoryTypeName : "-" }}
      </div>
    </a-table>
  </a-modal>
</template>

<script>
// import BaseListSelect from '../select/BaseListSelect.vue'
import TypeList from '@/components/Common/components/Type.vue';
export default {
  props: ['visible', 'formulaIdList', 'formulaSelectedRows'],
  components: { TypeList },
  data() {
    return {
      title: <p>删除原料<span style="font-size: 12px;color: #999;font-weight: normal;margin-left: 10px;">将原料从选中配方中删除</span></p>,
      list: [],
      y: 300,
      columns: [
        {
          title: '原料名称',
          dataIndex: 'name',
          width: 180,
          ellipsis: true,
        },
        {
          title: '代码',
          dataIndex: 'code',
          width: 100,
          ellipsis: true,
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "rawTypeName" },
        },
        {
          title: '库存量(Ton)',
          dataIndex: 'storageWeight',
          width: 100,
          ellipsis: true,
          customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(3);
          }
        },
        {
          title: '状态/类目归属',
          dataIndex: 'status',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        // {
        //   title: '单位',
        //   dataIndex: 'unit',
        //   width: 100,
        //   ellipsis: true,
        // },
      ],
      selectedRowKeys: [],
      selectedRows: [],
      cacheData: [],
      searchKey: '',
      types: [],
      typeId: undefined
    };
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows;
        },
        selectedRowKeys: this.selectedRowKeys
      };
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.searchKey = '';
        this.typeId = undefined;
        this.list = [];
        this.getList();
      } else {
        this.searchKey = '';
        this.typeId = undefined;
        this.selectedRowKeys = [];
        this.selectedRows = [];
      }
    },
  },
  methods: {
    ok() {
      let formulaRawList = this.selectedRowKeys.map(rawId => {
        return { rawId };
      });
      let data = {
        formulaIdList: this.formulaIdList, formulaRawList
      };
      this.$http.post('/nhf-app/formulaManage/batchDelRawToFormulas', data).then(res => {
        let { success, msg } = res || {};
        let feild = 'warning';
        if (success) feild = 'success';
        this.$message[feild](msg);
        this.$emit('close', true);
      });
    },
    cancel() {
      this.$emit('close', false);
    },
    getList() {
      let params = {
        formulaIdList: this.formulaIdList,
        factoryId: window.localStorage.getItem('factoryId'),
      };
      this.$http.post('/nhf-app/formulaManage/selectFormulaRaws', params).then(res => {
        let { success, data } = res || {};
        if (success) {
          this.list = data || [];
          this.cacheData = JSON.parse(JSON.stringify(data || []));
        } else {
          this.list = [];
        }
      });
    },
    filterList() {
      // this.selectedRowKeys = []
      // this.selectedRows = []
      let list = JSON.parse(JSON.stringify(this.cacheData));
      // 输入关键字
      if (this.searchKey) {
        list = list.filter(e => e.code.indexOf(this.searchKey) >= 0 || e.name.indexOf(this.searchKey) >= 0);
      }
      // 类型id
      if (this.typeId) {
        list = list.filter(e => e.typeId === this.typeId);
      }
      this.list = list || [];
    },
    setVal(val) {
      if (val) {
        this.typeId = val ? val[val.length - 1] : undefined;
      } else {
        this.typeId = undefined;
      }
      this.filterList();
    },
    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },
  }
};
</script>

<style lang="scss" scoped>
.raw-model-info-row {
  margin-bottom: 8px;

  span {
    color: #999;
  }
}

::v-deep .ant-modal-body {
  padding-top: 8px;
}
</style>
